import request from "@/utils/request";
import { parseStrEmpty } from "@/utils/benagen";

// 查询用户列表
export function listUser(query) {
  return request({
    url: "/system/user/list",
    method: "get",
    params: query
  });
}

// 获取用户列表（全局） 不会应为权限而被限制查询范围
export function listGlobal(data) {
  return request({
    url: `/system/user/listGlobal?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
    method: "post",
    data
  });
}

// 查询用户详细
export function getUser(userId) {
  return request({
    url: "/system/user/" + parseStrEmpty(userId),
    method: "get"
  });
}

//  查询用户详细（全局） 不会因为权限而被限制查询范围
export function getUserGlobal(userId) {
  return request({
    url: "/system/user/userDetail/" + parseStrEmpty(userId),
    method: "get"
  });
}

// 新增用户
export function addUser(data) {
  return request({
    url: "/system/user",
    method: "post",
    data: data
  });
}

// 修改用户
export function updateUser(data) {
  return request({
    url: "/system/user",
    method: "put",
    data: data
  });
}

// 删除用户
export function delUser(userId) {
  return request({
    url: "/system/user/" + userId,
    method: "delete"
  });
}

// 用户密码重置
export function resetUserPwd(userId, password) {
  const data = {
    userId,
    password
  };
  return request({
    url: "/system/user/resetPwd",
    method: "put",
    data: data
  });
}

// 用户状态修改
export function changeUserStatus(userId, status) {
  const data = {
    userId,
    status
  };
  return request({
    url: "/system/user/changeStatus",
    method: "put",
    data: data
  });
}

// 查询用户个人信息
export function getUserProfile() {
  return request({
    url: "/system/user/profile",
    method: "get"
  });
}

// 修改用户个人信息
export function updateUserProfile(data) {
  return request({
    url: "/system/user/profile",
    method: "put",
    data: data
  });
}

// 用户密码重置
export function updateUserPwd(oldPassword, newPassword) {
  const data = {
    oldPassword,
    newPassword
  };
  return request({
    url: "/system/user/profile/updatePwd",
    method: "put",
    data: data
  });
}

// 用户头像上传
export function uploadAvatar(data) {
  return request({
    url: "/system/user/profile/avatar",
    method: "post",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    data: data
  });
}

// 查询授权角色
export function getAuthRole(userId) {
  return request({
    url: "/system/user/authRole/" + userId,
    method: "get"
  });
}

// 保存授权角色
export function updateAuthRole(data) {
  return request({
    url: "/system/user/authRole",
    method: "put",
    params: data
  });
}

// 查询部门下拉树结构
export function deptTreeSelect() {
  return request({
    url: "/system/user/deptTree",
    method: "get"
  });
}

//  查询部门下拉树结构（全局）   不会应为权限而被限制查询范围
export function deptTreeGlobal() {
  return request({
    url: "/system/user/deptTreeGlobal",
    method: "post",
    data: {}
  });
}

// 同步CRM客户销售账号
export function synCrmSaleCustomerAccount() {
  return request({
    url: "/system/user/synCrmSaleCustomerAccount",
    method: "get",
    timeout: 1e11
  });
}

/**
 * @description 获取登录链接token
 */
export function getAccessToken(userId) {
  return request({
    url: `/system/user/getAccessToken/${userId}`,
    method: "GET"
  });
}

//  通过邮件来登录
export function getTokenByHash(access_token) {
  return request({
    url: `/auth/loginByToken/${access_token}`,
    method: "POST"
  });
}
